import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Every `*_controller.js` under these roots is registered. The identifier is
// the filename without the suffix, underscores to hyphens, e.g.
// `timer_button_component_controller.js` -> `timer-button-component`; it
// ignores the folder, so filenames must be unique across both roots.
//
//   app/components/          UI Kit (ui/<component>_component/) and feature components
//   app/javascript/stimulus/ page-level controllers (pages/<page>/) and shared ones
const roots = [
  require.context('../../components', true, /_controller\.js$/), // eslint-disable-line no-undef
  require.context('.', true, /_controller\.js$/), // eslint-disable-line no-undef
];

const identifierFor = (key) => key.split('/').pop().replace(/_controller\.js$/, '').replace(/_/g, '-');

roots.forEach((context) => {
  context.keys().forEach((key) => {
    const controller = context(key).default;
    if (controller) application.register(identifierFor(key), controller);
  });
});

export default application;
